import { createReducer } from '@reduxjs/toolkit';
import { dismissNotification, insertNotification } from './actions';
import { NotificationsState } from './types';

const initialState: NotificationsState = {
  notificationsById: {},
};

const notificationsReducer = createReducer(initialState, (builder) => {
  /**
   * Insert new UI notification
   */
  builder.addCase(insertNotification, (state, action) => {
    const notification = action.payload;
    state.notificationsById[notification.id] = notification;
  });
  /**
   * Remove UI notification if it is still visible
   */
  builder.addCase(dismissNotification, (state, action) => {
    const notificationId = action.payload;
    delete state.notificationsById[notificationId];
  });
});

export default notificationsReducer;
